import type { Variants } from 'framer-motion';
import { AnimatePresence, m } from 'framer-motion';
import type { CSSProperties } from 'react';
import type { IToastMessagePrv } from '../state/interface';
import { TypeToIcon } from '../util/conversion';
import ToastView from './Toast';

const SIZE_CONTAINERHEIGHT_VH = 13;
const SIZE_SHADOWHEIGHT_VH = 6;

enum ANIMATION_STATES {
    initial = 'initial',
    enter = 'enter',
    exit = 'exit',
}

const VARIANTS: Variants = {
    [ANIMATION_STATES.initial]: {
        top: `-${
            SIZE_CONTAINERHEIGHT_VH + SIZE_SHADOWHEIGHT_VH
        }vh` /* Make sure the initial position also hides the shadow too */,
    },
    [ANIMATION_STATES.enter]: {
        top: '-1vh',
    },
    [ANIMATION_STATES.exit]: {
        top: `-${SIZE_CONTAINERHEIGHT_VH + SIZE_SHADOWHEIGHT_VH}vh`,
    },
};

const STYLE_CONTAINER: CSSProperties = {
    zIndex: 10000,
    position: 'relative',
    top: `-${SIZE_CONTAINERHEIGHT_VH + SIZE_SHADOWHEIGHT_VH}vh`,
    width: '100vw',
    height: `${SIZE_CONTAINERHEIGHT_VH}vh`,
};

const STYLE_VIEW: CSSProperties = {
    position: 'relative',
    width: '100%',
    height: '100%',
};

function ToastMessage(props: IToastMessagePrv): JSX.Element {
    return (
        <AnimatePresence key="Toast">
            <m.div
                key={props.id}
                variants={VARIANTS}
                animate={ANIMATION_STATES.enter}
                exit={ANIMATION_STATES.exit}
                style={STYLE_CONTAINER}
            >
                <ToastView text={props.text} icon={TypeToIcon(props.type)} style={STYLE_VIEW} />
            </m.div>
        </AnimatePresence>
    );
}

export default ToastMessage;
